import { FormsConstants } from './forms-constants';
import { FunctionalElement, FUNCTIONAL_ELEMENT_TYPE } from './functional-element';

export type DatePerformed = Readonly<{
    dateLabel: string;
    date: string;
    dateXmlId?: string; // only used by cosima
    dayXmlId?: string; // only used by astoria
    monthXmlId?: string; // only used by astoria
    yearXmlId?: string; // only used by astoria
    description?: string; // only used in cosima
    type: FUNCTIONAL_ELEMENT_TYPE.DATE_PERFORMED | FUNCTIONAL_ELEMENT_TYPE.DATE;
    function?: FormsConstants.FUNCTION_TYPE; // only used by cosima
}> &
    FunctionalElement;

export const initialDatePerformedState: DatePerformed = {
    id: -1,
    dateLabel: '',
    date: '',
    dayXmlId: '',
    monthXmlId: '',
    yearXmlId: '',
    parentId: -1,
    type: FUNCTIONAL_ELEMENT_TYPE.DATE_PERFORMED,
    function: undefined,
    controllingCheckpoint: '',
    contentLoadedFromXml: false,
    disabled: false,
    controllingOption: undefined,
};

export function isDatePerformed(f: FunctionalElement): f is DatePerformed {
    return f.type === FUNCTIONAL_ELEMENT_TYPE.DATE_PERFORMED || f.type === FUNCTIONAL_ELEMENT_TYPE.DATE;
}
